import React from 'react';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

const CouponComponent = ({ company }) => {
  const {
    Name,
    CustomMessage = 'Congratulations! You are eligable for a discount.',
    DiscountCode,
    URL,
  } = company;


  return (
    <>
      <Typography
        component='h1'
        variant='h2'
        align='center'
        color='textPrimary'
        gutterBottom>
        {CustomMessage}
      </Typography>
      {DiscountCode ? (
        <>
        <Typography variant='h5' align='center' color='textSecondary' gutterBottom>
        {`Use discount code `} 
        </Typography>
        <Typography variant='h5' align='center' color='textSecondary' gutterBottom>
          <b>{`${DiscountCode}`}</b>
        </Typography>
        {/* <Typography variant='h5' align='center' color='textSecondary' gutterBottom>
          at
        </Typography> */}
        <Typography variant='h5' align='center' color='textSecondary'>
        {<Link href={URL} target='_blank' rel='noopener'>
          {Name}
        </Link>}
        </Typography>
        
      </>
      ) : (<Typography variant='h5' align='center' color='textSecondary' paragraph>
      {'Please visit' } <Link href={URL} target='_blank' rel='noopener'>
        {Name}
      </Link> {'to receive your discount'}.
      
    </Typography>)}
      
    </>
  );
};

export default CouponComponent;
